export type ImpactFluidKind='blood'|'plasma'|'aether'|'spark'
export type ImpactFluidEvent={attackerId:string;defenderId:string;damage:number;kind:ImpactFluidKind;color:string;droplets:number;viscosity:number;lifeMs:number;impulse:number}
export function fluidKindForFighter(id:string):ImpactFluidKind{
 if(/vaelthar|quantum|rift|void|wisp|timekeeper/i.test(id))return'aether'
 if(/sentinel|cyber|golem|warden/i.test(id))return'spark'
 if(/angel|jhadson|elyon|celestial/i.test(id))return'plasma'
 return'blood'
}
export function createImpactFluidEvent(attackerId:string,defenderId:string,damage:number):ImpactFluidEvent{
 const kind=fluidKindForFighter(defenderId)
 const color=kind==='blood'?'#b91c1c':kind==='plasma'?'#f8fafc':kind==='aether'?'#a855f7':'#facc15'
 return{attackerId,defenderId,damage,kind,color,droplets:Math.max(6,Math.min(42,Math.round(damage/18))),viscosity:kind==='blood'?.72:kind==='spark'?.16:.42,lifeMs:Math.max(260,Math.min(1400,220+damage*7)),impulse:Math.max(.08,Math.min(1.4,damage/120))}
}
export function assertImpactFluid(event:ImpactFluidEvent){if(!event.color||event.droplets<1||event.lifeMs<120)throw new Error('Invalid impact fluid event');return event}

export function impactFluidForCue(kind:string,attackerId:string,defenderId:string,damage:number){
 if((kind!=='hit'&&kind!=='throw')||!Number.isFinite(damage)||damage<=0)return null
 return assertImpactFluid(createImpactFluidEvent(attackerId,defenderId,damage))
}
